<template>
  <div>
    <div v-if="documentData" :style="{ height: containerHeight + 'px', overflow: 'auto' }">
      <iframe :src="documentData" width="100%" height="100%"></iframe>
    </div>
    <div v-if="errorMessage">
      <p>{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      documentData: null,
      errorMessage: null,
      containerHeight: 500,
    };
  },
  mounted() {
    this.calculateHeight();
    window.addEventListener('resize', this.calculateHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateHeight);
  },
  created() {
    this.fetchDocument();
  },
  methods: {
    calculateHeight() {
      // Subtract space for headers, footers, etc.
      const windowHeight = window.innerHeight;
      const offset = 100; // Adjust based on your layout
      this.containerHeight = windowHeight - offset;
    },
    async fetchDocument() {
      try {


        if (this.$route.path.startsWith('/image-display')) {
          const transactionId = this.$route.params.txnId;
          const response = await axios.get(`/api/bluestar/${transactionId}`, {
            responseType: 'arraybuffer',
          });
          if (response.status === 200) {
            const contentType = response.headers['content-type'];
            const pdfBlob = new Blob([response.data], { type: contentType });
            this.documentData = URL.createObjectURL(pdfBlob);
          } else {
            this.errorMessage = 'Failed to fetch the document.';
          }

        }
        else if (this.$route.path.startsWith('/s3-display')) {
          try {
            const fwConfig = this.$route.query;

            if (!fwConfig?.conName) {
              throw new Error('Connection name is missing');
            }

            const fileName = `Service Ticket_${fwConfig.fileName}.pdf`;
            const fileKey = this.buildS3FileKey(fileName);

            const response = await axios.post(
                '/api/s3-file-view',
                {
                  fileKey:fileKey,                     // S3 key
                  connectionName: fwConfig.conName, // AWS connection name
                  provider:fwConfig.provider
                },
                { responseType: 'arraybuffer' }
            );

            if (response.status === 200) {
              const contentType = response.headers['content-type'];
              const blob = new Blob([response.data], { type: contentType });
              this.documentData = URL.createObjectURL(blob);
            } else {
              this.errorMessage = 'Failed to fetch the S3 file.';
            }

          } catch (err) {
            console.error(err);
            this.errorMessage = err.message || 'Failed to fetch the S3 file';
          }
        }
        else if (this.$route.path.startsWith('/s3-file-display')) {
          try {
            const fwConfig = this.$route.query;

            if (!fwConfig?.conName) {
              throw new Error('Connection name is missing');
            }

            const response = await axios.post(
                '/api/s3-file-view',
                {
                  fileKey:fwConfig.fileName,                     // S3 key
                  connectionName: fwConfig.conName, // AWS connection name
                  provider:fwConfig.provider
                },
                { responseType: 'arraybuffer' }
            );

            if (response.status === 200) {
              const contentType = response.headers['content-type'];
              const blob = new Blob([response.data], { type: contentType });
              this.documentData = URL.createObjectURL(blob);
            } else {
              this.errorMessage = 'Failed to fetch the S3 file.';
            }

          } catch (err) {
            console.error(err);
            this.errorMessage = err.message || 'Failed to fetch the S3 file';
          }
        }

        else {
          this.errorMessage = 'Unknown path.';
        }
      } catch (error) {
        console.error('Error fetching document:', error);
        this.errorMessage = 'An error occurred while fetching the document.';
      }
    },
    buildS3FileKey(rawFileName) {
      // Extract _A240703 or _B240703
      const match = rawFileName.match(/_(A|B)(\d{2})(\d{2})(\d{2})/);

      if (!match) {
        throw new Error('Invalid file name format');
      }

      const typePrefix = match[1]; // A or B
      const year = `20${match[2]}`; // 24 -> 2024
      const monthNum = match[3];
      const day = match[4];

      const monthMap = {
        '01': 'Jan', '02': 'Feb', '03': 'Mar',
        '04': 'Apr', '05': 'May', '06': 'Jun',
        '07': 'Jul', '08': 'Aug', '09': 'Sep',
        '10': 'Oct', '11': 'Nov', '12': 'Dec'
      };

      const month = monthMap[monthNum];
      if (!month) {
        throw new Error('Invalid month in file name');
      }

      const folderPrefix = typePrefix === 'A' ? 'PMS_' : 'Non_PMS_';

      return `${folderPrefix}${year}/${year}/${month}/${day}/${rawFileName}`;
    },
  },
};
</script>
